import "./App.css";

// bootstrap links
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

// import AnimatedCursor from "react-animated-cursor";

import NavBar from "./components/NavBar/NavBar";
import AboutUs from "./components/About-us/AboutUs";
import Hero from "./components/Hero/Hero";
import OurProject from "./components/Our-Projects/OurProject";
import InfrastructureFacilities from "./components/Infrastructure-Facilities/InfrastructureFacilities";
import APCRDAProposedLayout from "./components/APCRDAProposedLayout/APCRDAProposedLayout";
import LocationMap from "./components/LocationMap/LocationMap";
import ContactUs from "./components/ContactUs/ContactUs";
import FooterSection from "./components/Footer/FooterSection";
import ContactForm from "./components/ContactUs/ContactForm";
import { Route, Routes, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import DownloadIcon from './components/Download-Pdf/DownloadPdf';


function App() {
  const location = useLocation();

  const isSitemap = location.pathname === "/sitemap.xml" || location.pathname === "/sitemap-misc.xml";
  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "name": "Skyline Infra Heights Pvt. Ltd.",
        "legalName": "Skyline Infra Heights Private Limited",
        "url": "https://skyline-infra.in/",
        "logo": "https://cdn.builder.io/api/v1/image/assets%2F7fa683a22a9c42d7a697097e1847f1c9%2F29271bd60206424f8936d70a338b0501",
        "description": "Skyline Infra Heights Pvt. Ltd. is a renowned real estate company based in Kanpur, Uttar Pradesh, specializing in residential and commercial projects with a commitment to quality and trust.",
        "foundingDate": "2010-12-22",
        "founders": [
          {
            "@type": "Person",
            "name": "Soma venkateshwarlu"
          },
        ],


        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Thirumala Enclave, 11-660 Phase 2, 1st floor",
          "addressLocality": "Above Kotak Mahindra Bank, Inner Ring Road",
          "addressRegion": "Guntur",
          "postalCode": "522034",
          "addressCountry": "IN"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+91-9848772866",
          "contactType": "Customer Service"
        },
        "sameAs": [
          "https://youtu.be/H9eTmhszVbc",
        ]

      },

      {
        "@type": "WebSite",
        "name": "Skyline Infra Heights Pvt. Ltd.",
        "url": "https://skyline-infra.in/",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://skyline-infra.in/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://skyline-infra.in/"
          },
        ]
      }
    ]
  }
  return (
    <>
      <Helmet>
        <title>Skyline Infra – Premium Open Plots in a Prime Location</title>
        <meta name="title" content="Skyline Infra – Premium Open Plots in a Prime Location" />
        <meta name="description" content="Explore 230 open plots ranging from 170 to 440 sq. yds, beautifully spread across 20.8 acres in a prime location. Invest in your dream property today." />
        <meta name="keywords" content="Skyline Infra, open plots, real estate, land for sale, prime location, property investment" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Skyline Infra" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="canonical" href="https://skyline-infra.in/" />


        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Skyline Infra" />
        <meta property="og:locale" content="en_IN" />
        <meta property="og:url" content="https://skyline-infra.in/" />
        <meta property="og:title" content="Skyline Infra – Premium Open Plots in a Prime Location" />
        <meta property="og:description" content="Explore 230 open plots ranging from 170 to 440 sq. yds, beautifully spread across 20.8 acres in a prime location. Invest in your dream property today." />
        <meta property="og:image" content="https://skyline-infra.in/og-image-wa.jpg?v=20260416d" />
        <meta property="og:image:secure_url" content="https://skyline-infra.in/og-image-wa.jpg?v=20260416d" />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="1024" />
        <meta property="og:image:height" content="576" />
        <meta property="og:image:alt" content="Skyline Infra Amaravati project image" />

        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://skyline-infra.in/" />
        <meta property="twitter:title" content="Skyline Infra – Premium Open Plots in a Prime Location" />
        <meta property="twitter:description" content="Explore 230 open plots ranging from 170 to 440 sq. yds, beautifully spread across 20.8 acres in a prime location. Invest in your dream property today." />
        <meta property="twitter:image" content="https://skyline-infra.in/og-image-wa.jpg?v=20260416d" />
        <meta property="twitter:image:alt" content="Skyline Infra premium open plots" />
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      </Helmet>
      {!isSitemap && <NavBar />}
      {!isSitemap && <DownloadIcon />}
      <Routes>
        {" "}
        <Route
          path="/"
          element={
            <>
              <section id="home">
                <Hero />
              </section>
              <section id="about-us">
                <AboutUs />
              </section>
              <section id="our-projects">
                <OurProject />
                <APCRDAProposedLayout />
                <InfrastructureFacilities />
              </section>
              <section id="location-map">
                <LocationMap />
              </section>
              <section id="contact-us">
                <ContactForm />
                <ContactUs />
              </section>
              <FooterSection />
            </>
          }
        />
      </Routes>
    </>
  );
}

export default App;
